module.exports = __webpack_public_path__ + "static/media/mock_img6.79ef3e30.jpg";